import React from 'react';

import Table from '../common/table/table';
import THead from '../common/table/tHead';
import TBody from '../common/table/tBody';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import DateFormat from '../common/dateFormat/DateFormat';

const getDescricaoEvento = tipo => {
	const descricoes = {
		INICIO_PRODUCAO_CARGA: 'Início da produção',
		CANCELAMENTO_INICIO_PRODUCAO_CARGA: 'Cancelamento do início',
		FINALIZACAO_PRODUCAO_CARGA: 'Finalização da produção',
		REABERTURA_PRODUCAO_CARGA: 'Reabertura da produção',
		INCLUSAO_LOTE: 'Lote informado',
		ALTERACAO_LOTE: 'Lote alterado'
	};

	return descricoes[tipo] || tipo;
};

export default props => {
	if (!props.idCarga) {
		return null;
	}

	return (
		<div
			className='modal fade show'
			tabIndex='-1'
			role='dialog'
			style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.45)' }}>
			<div className='modal-dialog modal-xl' role='document'>
				<div className='modal-content'>
					<div className='modal-header bg-primary'>
						<h5 className='modal-title'>
							Histórico da Produção da Carga {props.idCarga}
						</h5>
						<button
							type='button'
							className='close text-white'
							title='Fechar'
							onClick={props.onFechar}>
							<span aria-hidden='true'>&times;</span>
						</button>
					</div>

					<div className='modal-body' style={{ maxHeight: '70vh', overflowY: 'auto' }}>
						<Table responsive border striped>
							<THead>
								<Tr>
									<Th width={145}>Data/Hora</Th>
									<Th width={190}>Evento</Th>
									<Th width={95}>Produção</Th>
									<Th width={75}>Batida</Th>
									<Th width={120}>Anterior</Th>
									<Th width={120}>Novo</Th>
									<Th width={160}>Usuário</Th>
									<Th>Motivo</Th>
								</Tr>
							</THead>
							<TBody>
								{(props.lista || []).map(item => (
									<Tr key={item.id}>
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora)}</Td>
										<Td>{getDescricaoEvento(item.tipo)}</Td>
										<Td alignCenter>{item.id_producao || '-'}</Td>
										<Td alignCenter>{item.numero_batida || '-'}</Td>
										<Td>{item.valor_anterior || '-'}</Td>
										<Td>{item.valor_novo || '-'}</Td>
										<Td>{item.nome_usuario}</Td>
										<Td>{item.motivo || '-'}</Td>
									</Tr>
								))}
								{!(props.lista || []).length &&
									<Tr>
										<Td colSpan={8} alignCenter>Nenhum histórico de produção registrado.</Td>
									</Tr>}
							</TBody>
						</Table>
					</div>

					<div className='modal-footer'>
						<button type='button' className='btn btn-secondary' onClick={props.onFechar}>
							Fechar
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
